import axios from "axios";
import { jwtDecode } from "jwt-decode";

const apiRequest = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://ng-api-p21r.onrender.com/api",
});

// 🚀 Request Interceptor: проверяем срок действия токена
apiRequest.interceptors.request.use(
  (config) => {
    const storedData = localStorage.getItem("user");
    let parsedData = null;

    try {
      parsedData = storedData ? JSON.parse(storedData) : null;
    } catch (error) {
      console.error("❌ Ошибка при парсинге user:", error);
      localStorage.removeItem("user");
      return config; // Продолжить без токена
    }

    const token = parsedData?.token;

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const isExpired = decoded.exp * 1000 < Date.now();

        if (isExpired) {
          console.warn("⏰ Токен истёк — удаляю");
          localStorage.removeItem("user");
          window.location.href = "/login"; // Можно заменить на модальное окно или лейаут
          return Promise.reject(new Error("Token expired"));
        }

        config.headers.Authorization = `Bearer ${token}`;
      } catch (decodeError) {
        console.error("❌ Невозможно декодировать токен:", decodeError);
        localStorage.removeItem("user");
        window.location.href = "/login";
        return Promise.reject(new Error("Invalid token"));
      }
    }

    return config;
  },
  (error) => {
    console.error("🔥 Request interceptor error:", error);
    return Promise.reject(error);
  }
);

// 🛡️ Response Interceptor: отлавливаем ошибки от сервера
apiRequest.interceptors.response.use(
  (response) => response,
  (error) => {
    const isExpired = error.response?.data?.expired;

    if (isExpired) {
      console.warn("🔒 Сервер сообщил об истекшем токене — удаляю и перенаправляю");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default apiRequest;
